import { type RouteLocationNormalized, type RouteRecordRaw } from 'vue-router';

import { routerHelper } from '@/services/router-helper';

import { ROUTE_DATA } from './../../constants/routes.constants';

const EvaluationRead = (): unknown => {
    return import(/* webpackPrefetch: true */ './evaluation-read-page.vue');
};
const EvaluationEdition = (): unknown => {
    return import(/* webpackPrefetch: true */ './evaluation-edition-page.vue');
};

export const evaluationReadRoute: RouteRecordRaw = {
    ...ROUTE_DATA.EVALUATION_READ_PAGE,
    components: {
        main: EvaluationRead
    },
    props: {
        main(route: RouteLocationNormalized): { evaluationId?: number } {
            return { evaluationId: routerHelper.parseParamToInt(route.params.id as string) };
        }
    },
    meta: {
        noMenu: true
    }
};

export const evaluationEditionRoute: RouteRecordRaw = {
    ...ROUTE_DATA.EVALUATION_EDITION_PAGE,
    components: {
        main: EvaluationEdition
    },
    props: {
        main(route: RouteLocationNormalized): { evaluationId?: number } {
            return { evaluationId: routerHelper.parseParamToInt(route.params.id as string) };
        }
    },
    meta: {
        noMenu: true
    }
};
